/**
 * Supported reanimate values.
 * 'enter' will re-enter the animation.
 * 'exit-then-enter' will exit the animation and then enter it again.
 */
export enum Reanimate {
	enter = 'enter',
	exit_then_enter = 'exit_then_enter',
}
